import { Zap, MessageCircle, FileCheck2, MapPin, Eye, HeartHandshake } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import PublicLayout from "@/components/PublicLayout";
import PathHero from "@/components/PathHero";
import StatBig from "@/components/sections/StatBig";
import SalesGrid from "@/components/sections/SalesGrid";
import Steps from "@/components/sections/Steps";
import FormSection from "@/components/sections/FormSection";
import FAQ from "@/components/FAQ";

const TENANT_IMG =
  "https://images.unsplash.com/photo-1758523670960-eb5512da12e8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHw0fHxoYXBweSUyMGZhbWlseSUyMG5ldyUyMGhvbWUlMjBtb3ZpbmclMjBrZXlzfGVufDB8fHx8MTc4NzU5OTgwNnww&ixlib=rb-4.1.0&q=85";
const SALES_ICONS = [Zap, MessageCircle, FileCheck2, MapPin, Eye, HeartHandshake];

export default function TenantPage() {
  const { t } = useLang();
  const p = t.tenant;

  return (
    <PublicLayout variant="tenant">
      <PathHero
        image={TENANT_IMG}
        badge={p.hero.badge}
        title={p.hero.title}
        subtitle={p.hero.subtitle}
        cta={p.hero.cta}
        note={p.hero.note}
        trust={t.chooser.trust[0]}
      />

      <StatBig overline={p.metrics.overline} title={p.metrics.title} items={p.metrics.items} disclaimer={p.metrics.disclaimer} />
      <FormSection kind="tenant" />
      <SalesGrid overline={p.sales.overline} title={p.sales.title} cards={p.sales.cards} icons={SALES_ICONS} surface />
      <Steps overline={p.steps.overline} title={p.steps.title} items={p.steps.items} disclosure={p.steps.disclosureShort} />
      <FAQ overline={p.faq.overline} title={p.faq.title} items={p.faq.items} />
    </PublicLayout>
  );
}
